export default __webpack_public_path__ + "static/media/BSATS.94642d70.png";